
import { Component, Vue, Watch } from 'vue-property-decorator'
import { ORDERAPI } from '@/api/orders'
import { TicketsModule } from '@/store/modules/tickets'
import { isEmojiCharacter } from '@/utils/hasEmoji'

@Component({
  components: {}
})
export default class RateContent extends Vue {
  private formdata: any = {
    is_resolved: '',
    rate: 0,
    comment: ''
  }
  private hasComment: boolean = false // 是否已经评价过
  private isRatePage = this.$route.name === 'orderRateIndex' // 是否访问的是满意度评价页，否则为弹框访问

  get currentTicket() {
    return TicketsModule.currentTicket || {}
  }

  mounted() {
    this.getComment()
  }

  private handleResolve(isResolved: number) {
    if (this.hasComment) return
    this.formdata.is_resolved = isResolved
  }

  // 评论提交
  private handleSubmit() {
    if (this.formdata.is_resolved === '') {
      this.$message({
        message: '请选择是否解决问题！',
        type: 'error',
        showClose: true
      })
      return
    } else if (this.formdata.rate === 0) {
      this.$message({
        message: '请对本次服务进行评分！',
        type: 'error',
        showClose: true
      })
      return
    } else if ((this.formdata.rate < 4 || !this.formdata.is_resolved) && !this.formdata.comment) {
      this.$message({
        message: '请填写本次服务的评价描述',
        type: 'error',
        showClose: true
      })
      return
    }
    if (this.formdata.comment && isEmojiCharacter(this.formdata.comment)) {
      this.$message({
        message: '评价中请不要添加Emoji表情！',
        type: 'error',
        showClose: true
      })
      return
    }
    ORDERAPI.appraiseTicket({
      ticket_number: this.$route.params.tid || this.currentTicket.tid,
      ticket_type: this.$route.params.ticketType || this.currentTicket.ticket_type,
      is_resolved: this.formdata.is_resolved,
      rate: this.formdata.rate,
      comment: this.formdata.comment
    }).then((res) => {
      if (res.stat === 1) {
        res.data = '本次服务满意度评价成功'
        this.$emit('handleSuccess', res)
        this.hasComment = true
        if (!this.isRatePage) {
          this.handleClose()
        }
      }
    }).catch(() => {})
  }


  // 获取评论
  private getComment() {
    ORDERAPI.appraiseResult({
      tid: this.$route.params.tid || this.currentTicket.tid,
      ticket_type: this.$route.params.ticketType || this.currentTicket.ticket_type
    }).then((res) => {
      if (res.stat === 1 && res.data.length === 0) {
       this.hasComment = false
      } else {
        this.hasComment = true
        res.data[0].comment = res.data[0].comment || '无'
        this.formdata = res.data[0]
      }
    }).catch(() => {})
  }

  // 关闭弹框
  private handleClose() {
    TicketsModule.ToggleDialogStatus({
      name: 'rateDialog',
      value: false
    })
  }
}
